<div class="card card-danger">
    <div class="card-header">
      <div class="float-left"><h5> Carriers invoice files </h5></div>
      <div class="float-right">
        <div class="btn-group" role="group" aria-label="Basic example">
          <button (click)="showFind()" type="button" class="btn btn-sm btn-outline-info"><i class="fa fa-search" aria-hidden="true"></i> Find</button>
          <button (click)="showNew()" type="button" class="btn btn-sm btn-outline-success"><i class="fa fa-plus" aria-hidden="true"></i> Add new </button>
        </div>
      </div>
    </div>

    <div class="card-body">
      <div class="row">
        <div class="col">
          <div *ngIf="Mode==FormModes.Find">

            <!--<form #FormFind="ngForm" (ngSubmit)="onSubmit(FormFind)">

    </form>-->
            <div class="row" style="margin-left: 0px;">
              <div class="col-sm-6">
                <div class="form-group row">
                  <label for="carrierSymbol" class="col-sm-3 col-form-label" style="position: relative; top: 6px;">Carrier invoice file label </label>
                  <div class="col-sm-9" style="margin-left: -17px; height: 0px;" >
                    <!--<input [(ngModel)]="FileLabel" type="text" pInputText size="50" (input)="InvoiceFilesDt.filter($event.target.value, 'Label', 'contains')" class="form-control form-control-sm" />-->
                    <!-- <input [(ngModel)]="FileLabel" type="text" size="50" class="form-control form-control-sm" /> -->
                    <mat-form-field appearance="outline">
                      <mat-label>Name</mat-label>
                      <input matInput [(ngModel)]="FileLabel" type="text" size="50" />
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12" style="position: relative; top: 16px;">
                <div class="text-center m-3">
                  <button type="button" (click)="onSubmit()" class="btn btn-sm btn-info mx-1"><i class="fa fa-search" aria-hidden="true"></i> Search </button>
                  <button type="button" class="btn btn-sm btn-outline-secondary mx-1" style="color: white; background-color: #2f72ab;" (click)="resetForm()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel </button>
                </div>
                <br />
              </div>
            </div>
          </div>
          <div *ngIf="Mode==FormModes.New">
            <form #FormNew="ngForm" (ngSubmit)="onSubmit(FormNew)">
              <div class="row">
                <div class="col-sm-6 ml-auto">
                  <div class="form-group row" style=" margin-left: 35px;">
                    <label for="carrierSymbol" class="col-sm-3 col-form-label">Carrier</label>
                    <div class="col-sm-9" style=" margin-left: -45px;">
                      <!-- <p-dropdown [filter]="true" filterBy="label" [options]="Carriers" [(ngModel)]="Carrier" optionLabel="name" id="CarrierOption" name="CarrierOption" required #CarrierOption="ngModel" placeholder="Select carrier" [showClear]="true"></p-dropdown> -->
                      <mat-form-field appearance="outline">
                        <mat-label>Select Carrier</mat-label>
                        <mat-select [(ngModel)]="Carrier" id="CarrierOption" name="CarrierOption" required #CarrierOption="ngModel">
                          <mat-option *ngFor="let Carrier of Carriers" [value]="Carrier.id">
                            {{Carrier.name}}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                      <div *ngIf="CarrierOption.invalid && (CarrierOption.dirty || CarrierOption.touched)" class="text-danger small">
                        <div *ngIf="CarrierOption.errors.required">
                          Carrier is required.
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group row" style=" margin-left: 35px;">
                    <label for="FileLabel" class="col-sm-3 col-form-label">Label</label>
                    <div class="col-sm-9" style=" margin-left: -45px;">
                      <!-- <input [(ngModel)]="InvoiceFile.label" #FileLabel="ngModel" required maxlength="50" type="text" class="form-control form-control-sm" id="FileLabel" name="FileLabel" /> -->
                      <mat-form-field appearance="outline">
                        <mat-label>Label</mat-label>
                        <input matInput [(ngModel)]="InvoiceFile.label" #FileLabel="ngModel" required maxlength="50" type="text"  id="FileLabel" name="FileLabel" />
                      </mat-form-field>
                      <div *ngIf="FileLabel.invalid && (FileLabel.dirty || FileLabel.touched)" class="text-danger small">
                        <div *ngIf="FileLabel.errors.required">
                          Label is required.
                        </div>
                        <div *ngIf="FileLabel.errors.maxlength">
                          Label must be less than 50 characters long.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group row">
                    <p-fileUpload [showUploadButton]="FormNew.valid"
                                  (change)="upload($event)"
                                  (onUpload)="onUploadComplete($event)"
                                  (onBeforeSend)="onBeforeSendFile($event)"
                                  (onBeforeUpload)="onBeforeUpload($event)"
                                  (onSelect)="dealWithFiles($event)"
                                  (onError)="onUploadError($event)"
                                  name="myfile"
                                  url="{{CarrierInvoiceFileControllerUrl}}"
                                  accept=".xlsx, .xls, .csv,"
                                  maxFileSize="2147483647"
                                  [showCancelButton]="false"
                                   chooseLabel="Choose">
                    </p-fileUpload>
                    <!-- <p-fileUpload name="demo[]" url="./upload.php" (onUpload)="onUpload($event)"
            multiple="multiple" accept="image/*" maxFileSize="1000000">
            <ng-template pTemplate="content">

            </ng-template>
    </p-fileUpload> -->
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <div class="text-center m-3">
                    <button type="button" class="btn btn-sm btn-outline-secondary mx-1" style="color: white; background-color: #2f72ab;" (click)="resetForm()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel </button>
                  </div>
                  <br />
                </div>
              </div>
            </form>
          </div>
          <div *ngIf="Mode == FormModes.Del">
            <div class="form-group row m-0">
              <label for="FileLabel" class="col-sm-3 col-form-label">Label:</label>
              <div class="col-sm-9">
                {{InvoiceFile.label}}
              </div>
            </div>
            <div class="form-group row m-0">
              <label for="FileLabel" class="col-sm-3 col-form-label">Carrier</label>
              <div class="col-sm-9">
                {{InvoiceFile.carriername}}
              </div>
            </div>
            <div class="form-group row m-0">
              <label for="FileLabel" class="col-sm-3 col-form-label">File name:</label>
              <div class="col-sm-9">
                {{InvoiceFile.fileOriginalName}}
              </div>
            </div>
            <div class="form-group row m-0">
              <div class="col-sm col-form-label">
                Version: {{InvoiceFile.fileVersion}}
              </div>
              <div class="col-sm col-form-label">
                Status:
                <a *ngIf="InvoiceFile.status==2" (click)="viewFileProcessingError(InvoiceFile)" style="cursor:pointer">
                  <span class="text-danger">{{FileParseStatus[InvoiceFile.status]}}</span>
                  <span class="ml-1 text-danger"><i class="fa fa-exclamation-circle" aria-hidden="true"></i></span>
                </a>
                <span *ngIf="InvoiceFile.status!=2" [ngClass]="InvoiceFile.status==0?'text-primary font-weight-bold':(InvoiceFile.status==1?'text-success':'')">{{FileParseStatus[InvoiceFile.status]}}</span>

              </div>
              <div class="col-sm col-form-label">
                Date: {{InvoiceFile.uploadedOn | date :'MM-dd-yyyy'}}
              </div>
            </div>
            <div class="form-group row m-0">
              <div class="col-sm-12">
                <div class="text-center m-3">
                  <button (click)="delete()" class="btn btn-sm btn-danger" type="button"><i class="fa fa-times" aria-hidden="true"></i> Delete</button>
                  <button (click)="resetForm()" class="btn btn-sm btn-outline-secondary mx-1" style="color: white; background-color: #2f72ab;" type="button"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="Mode != FormModes.New && Mode !=FormModes.Edit"class="row">
        <div class="col">
          <div class="mat-elevation-z8">
            <table mat-table [dataSource]="dataSource" matSort>


              <!-- <ng-container matColumnDef="Id">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> ID </th>
      <td mat-cell *matCellDef="let row">{{ row.id }}  </td>
    </ng-container> -->

              <ng-container matColumnDef="Label">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Label </th>
                <td mat-cell *matCellDef="let row"> {{ row.label }} </td>
              </ng-container>

              <ng-container matColumnDef="Carrier">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Carrier </th>
                <!-- <td mat-cell *matCellDef="let row"> {{ row.Carrier.name }} </td> -->
                <!-- <td mat-cell *matCellDef="let row"> {{ row.carrierId }}  </td> -->
                <!-- <td mat-cell *matCellDef="let row; let i=index"> {{ this.Carriers[i].name }}</td> -->
                <td mat-cell *matCellDef="let row"> {{ row.carriername }}</td>
              </ng-container>

              <ng-container matColumnDef="Name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
                <td mat-cell *matCellDef="let row">{{ row.fileOriginalName }}  </td>
              </ng-container>
              <ng-container matColumnDef="Ver.">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Ver. </th>
                <td mat-cell *matCellDef="let row"> {{ row.fileVersion }} </td>
              </ng-container>
              <ng-container matColumnDef="Date">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Date </th>
                <td mat-cell *matCellDef="let row"> {{ row.uploadedOn | date :'MM-dd-yyyy' }} </td>
              </ng-container>
              <ng-container matColumnDef="Status">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Status </th>
                <td mat-cell *matCellDef="let row">
                  <a *ngIf="row.status==2" (click)="viewFileProcessingError(row)" style="cursor:pointer">
                    <span class="text-danger">{{FileParseStatus[row.status]}}</span>
                    <span class="float-right text-danger"><i class="fa fa-exclamation-circle" aria-hidden="true"></i></span>
                  </a>
                  <span *ngIf="row.status!=2" [ngClass]="row.status==0?'text-primary font-weight-bold':(row.status==1?'text-success':'')">{{FileParseStatus[row.status]}}</span>
                </td>
              </ng-container>
              <ng-container matColumnDef="...">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> ... </th>
                <td mat-cell *matCellDef="let row">
                  <div class="btn-group btn-group-sm">
                    <a href="{{CarrierInvoiceFileControllerUrl}}/{{row.id}}?action=download" target="_blank" class="btn btn-sm btn-outline-success"><i class="fa fa-cloud-download" aria-hidden="true"></i></a>
                    <!-- <button (click)="viewInvoiceFile(row)" class="btn btn-sm btn-outline-primary"><i class="fa fa-eye" aria-hidden="true"></i></button> -->
                    <button (click)="showDel(row)" class="btn btn-sm btn-outline-danger"><i class="fa fa-times" aria-hidden="true"></i></button>
                  </div>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

              <!-- <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" colspan="4">No data matching the filter "{{input.value}}"</td>
    </tr> -->
            </table>

            <span style="position: relative; left: 40%; top: 40px; font-size: 13px;">There are {{InvoiceFiles?.length}} records</span>
            <!-- <tr class="mat-row" *matNoDataRow>
    <td class="mat-cell" colspan="4">There is no record</td>
  </tr> -->

            <mat-paginator #paginator [length]="this.InvoiceFiles?.length" [pageSizeOptions]="[5,10,50, 100]" aria-label="Select page of users"></mat-paginator>

          </div>
          <!-- <p-table #InvoiceFilesDt [value]="InvoiceFiles" [columns]="InvoiceFilesDtCols"
                   dataKey="Id"
                   [resizableColumns]="true"
                   [autoLayout]="true"
                   sortMode="multiple"
                   [paginator]="true"
                   [responsive]="true"
                   [rowsPerPageOptions]="[10,20,30]"
                   [rows]="10">
            <ng-template pTemplate="header" let-cols>
              <tr>
                <th [pSortableColumn]="c.field" *ngFor="let c of cols" scope="col">
                  {{c.header}}
                  <p-sortIcon [field]="c.field"></p-sortIcon>
                </th>
                <th scope="col">
                  ...
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-e>
              <tr [ngClass]="e.selected==true && Mode == FormModes.Edit ? 'text-primary font-weight-bold' : ( e.selected==true && Mode == FormModes.Del ? 'text-danger font-weight-bold':'' )" scope="row">
                <td><span class="text-muted">{{ e.Id }}</span></td>
                <td>{{ e.Label }}</td>
                <td>{{ e.Carrier.Name }}</td>
                <td>{{ e.FileOriginalName }}</td>
                <td>{{ e.FileVersion }}</td>
                <td>{{ e.UploadedOn | date :'MM-dd-yyyy' }}</td>
                <td>
                  <a *ngIf="e.Status==2" (click)="viewFileProcessingError(e)" style="cursor:pointer">
                    <span class="text-danger">{{FileParseStatus[e.Status]}}</span>
                    <span class="float-right text-danger"><i class="fa fa-exclamation-circle" aria-hidden="true"></i></span>
                  </a>
                  <span *ngIf="e.Status!=2" [ngClass]="e.Status==0?'text-primary font-weight-bold':(e.Status==1?'text-success':'')">{{FileParseStatus[e.Status]}}</span>
                </td>
                <td>
                  <div class="btn-group btn-group-sm">
                    <a href="{{CarrierInvoiceFileControllerUrl}}/{{e.Id}}?action=download" class="btn btn-sm btn-outline-success"><i class="fa fa-cloud-download" aria-hidden="true"></i></a>
                    <button (click)="showDel(e)" class="btn btn-sm btn-outline-danger"><i class="fa fa-times" aria-hidden="true"></i></button>
                  </div>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="summary">
              There are {{InvoiceFiles?.length}} invoice files
            </ng-template>
          </p-table> -->


        </div>
      </div>
    </div>
    <div class="card-footer">
    </div>
  </div>
                      <!--<button (click)="viewInvoiceFile(e)" class="btn btn-sm btn-outline-primary"><i class="fa fa-eye" aria-hidden="true"></i></button>-->
